// extracted by mini-css-extract-plugin
module.exports = {"event":"styles_event__1syB9","event__item":"styles_event__item__7jJA7","selectItem":"styles_selectItem__13hNA"};